// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__L9VBf","content":"RecentSearches_content__3qICs"};